import script from "./invoice-main.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-main.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__